import React, { useState, useEffect } from 'react';
import { useTranslation } from "react-i18next";
import { Route, Redirect, useHistory } from 'react-router-dom';
import { makeStyles } from '@mui/styles';
import AppBar from '@mui/material/AppBar';
import Avatar from '@mui/material/Avatar';
import CssBaseline from "@mui/material/CssBaseline";
import IconButton from '@mui/material/IconButton';
import LanguageIcon from '@mui/icons-material/Language';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import MenuItem from '@mui/material/MenuItem';
import Menu from '@mui/material/Menu';
import {httpClient} from "../../core/HttpClient";
import { Context } from "../../core/Context";
import Divider from "@mui/material/Divider";
const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
    },
    title: {
        flexGrow: 1,
        marginLeft: '10px',
    },
    menuButton: {
        padding: 0,
    },

}));

function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const Blank = ({ children}) => {
    const { t, i18n } = useTranslation();
    const [context, setContext] = useState({displayName: '', userId: '', success: false, fail: false});
    const [anchorEl, setAnchorEl] = useState(null);
    const history = useHistory();
    const classes = useStyles();
    const open = Boolean(anchorEl);

    useEffect(() => {
        let token = localStorage.getItem('token');
        if(!token){
            history.push('/signin');
        }

        const url = process.env.REACT_APP_API_BASE_URL + '/users/me';
        httpClient.get(url)
            .then(res => {
                if(res.data){
                    let user = {
                        userId: res.data._id,
                        displayName: res.data.displayName
                    };
                    setContext({ ...user, success: false, fail: false });
                } else {
                    history.push('/signin');
                }
            }).catch(e=>{
                history.push('/login');
            });
    }, [history]);

    const handleMenu = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleMenuClose = () => {
        setAnchorEl(null);
    };

    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }

        setContext({ ...context, success: false, fail: false });
    };

    const handleChangeLanguage = (lang) => {
        i18n.changeLanguage(lang);
        setAnchorEl(null);
    };

    const handleLogout = (event) => {
        localStorage.clear();
        window.location.href = '/login';
    };

    return (
        <div className='page page-dashboard'>
            <CssBaseline />
            <header>
                <AppBar elevation={0} position="static">
                    <Toolbar>
                        <Avatar alt={context.displayName} src={context.userId?`${process.env.REACT_APP_CDN_BASE_URL}/public/user/${context.userId}`: `${process.env.REACT_APP_CDN_BASE_URL}/public/assets/empty_user.jpg`} sx={{ mr: 1,width: 32, height: 32 }} />
                        <Typography variant="h6" noWrap={true} className={classes.title}>
                            {context.displayName}
                        </Typography>
                        <IconButton edge="start"
                                    onClick={handleMenu}
                                    color="inherit" aria-label="menu">
                            <LanguageIcon />
                        </IconButton>
                        <Menu
                            id="menu-appbar"
                            anchorEl={anchorEl}
                            anchorOrigin={{
                                vertical: 'top',
                                horizontal: 'right',
                            }}
                            keepMounted
                            transformOrigin={{
                                vertical: 'top',
                                horizontal: 'right',
                            }}
                            open={open}
                            onClose={handleMenuClose}
                        >
                            <MenuItem onClick={(e) => handleChangeLanguage('en-US')}>{t('languages.english')}</MenuItem>
                            <MenuItem onClick={(e) => handleChangeLanguage('th-TH')}>{t('languages.thai')}</MenuItem>
                            <Divider sx={{ my: 0.5 }} />
                            <MenuItem dense onClick={handleLogout}>{t('logout')}</MenuItem>
                        </Menu>
                    </Toolbar>
                </AppBar>
            </header>
            <div className={classes.content}>
                <Context.Provider value={[context, setContext]}>{children}</Context.Provider>
            </div>
            <Snackbar open={context.success}
                      anchorOrigin={{vertical:'top', horizontal:'center'}}
                      autoHideDuration={1500} onClose={handleClose}>
                <Alert onClose={handleClose} severity="success">
                    This is a success message!
                </Alert>
            </Snackbar>
            <Snackbar open={context.fail}
                      anchorOrigin={{vertical:'top', horizontal:'center'}}
                      autoHideDuration={1500} onClose={handleClose}>
                <Alert onClose={handleClose} severity="error">
                    This is a error message!
                </Alert>
            </Snackbar>
        </div>
    );
};

const BlankLayoutRoute = ({ component: Component, ...rest }) => {
    return (
        <Route
            {...rest}
            render={props => {
                if (localStorage.getItem('token')) {
                    return <Blank><Component {...props} /></Blank>
                } else {
                    return <Redirect to={
                        {
                            pathname: '/signin',
                            state: {
                                from: props.location
                            }
                        }
                    } />
                }
            }}
        />
    );
};

export default BlankLayoutRoute;